import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]

  connect() {
    // Start collapsed
    if (this.hasContentTarget) {
      this.contentTarget.style.maxHeight = "0"
      this.contentTarget.style.opacity = "0"
    }
  }

  toggle() {
    const content = this.contentTarget
    const isCollapsed = content.style.maxHeight === "0px" || content.style.maxHeight === ""

    if (isCollapsed) {
      // Expand
      content.style.maxHeight = content.scrollHeight + "px"
      content.style.opacity = "1"

      // Rotate icon if present
      if (this.hasIconTarget) {
        this.iconTarget.style.transform = "rotate(180deg)"
      }
    } else {
      // Collapse
      content.style.maxHeight = "0"
      content.style.opacity = "0"

      // Reset icon rotation
      if (this.hasIconTarget) {
        this.iconTarget.style.transform = "rotate(0deg)"
      }
    }
  }
}
